import type { IFacility } from "redux/reducers/models/facility";
import type { FacilityProfile } from "../domain/facility";
import { resolveEmailBuilderFacilityLogoSource } from "./emailBuilderFacilityLogo";

export function emailBuilderFacilityProfile(
  facility: IFacility | null | undefined,
): FacilityProfile {
  const name =
    typeof facility?.long_name === "string" && facility.long_name.trim().length > 0
      ? facility.long_name.trim()
      : "Facility";

  return {
    name,
    logoUrl: resolveEmailBuilderFacilityLogoSource(facility?.logo_source) ?? "",
    address: facility?.address_line_1 ?? "",
    city: facility?.city ?? "",
    state: facility?.province_code ?? "",
    zip: facility?.postal ?? "",
    phone: facility?.phone ?? "",
    email: facility?.email ?? facility?.customer_email ?? "",
    website: "",
  };
}
